module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _h('div', [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_loading),
      expression: "is_loading"
    }],
    staticClass: "globalLoading"
  }, [_vm._m(0)]), " ", _h('router-view', {
    class: _vm.is_app ? 'inApp' : '',
    attrs: {
      "title": _vm.title,
      "transition": 'page-pop-' + (_vm.direction === 'forward' ? 'in' : 'out')
    },
    slot: "main"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _h('span', [_h('img', {
    attrs: {
      "src": require("./assets/img/loading.gif")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdfd3ee0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 425
// module chunks = 28